import { useCallback, useState } from 'react';
import { EngagementResponse, EngagementQueryParams, ESnackbarStyle } from 'shared/types';
import { getEngagement } from 'services/api/dashboardService';
import { openNotification } from 'utils/notification-utils';

interface UseDashboardEngagementResult {
  engagement: EngagementResponse | null;
  isLoading: boolean;
  error: string | null;
  fetchEngagement: (params?: EngagementQueryParams) => Promise<void>;
}

const useDashboardEngagement = (): UseDashboardEngagementResult => {
  const [engagement, setEngagement] = useState<EngagementResponse | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchEngagement = useCallback(async (params?: EngagementQueryParams): Promise<void> => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await getEngagement(params);
      setEngagement(response.data);
    } catch (e: any) {
      const errorMessage = e.message || 'Failed to fetch engagement data';
      setError(errorMessage);
      openNotification(ESnackbarStyle.ERROR, errorMessage);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    engagement,
    isLoading,
    error,
    fetchEngagement
  };
};

export default useDashboardEngagement;
